export const HELPDESK_BASE = '/helpdesk';

export const helpdeskRoutes = {
  dashboard: HELPDESK_BASE,
  inbox: `${HELPDESK_BASE}/inbox`,
  conversations: `${HELPDESK_BASE}/conversations`,
  conversation: (id: string) => `${HELPDESK_BASE}/workspace?selected=${encodeURIComponent(id)}`,
  contacts: `${HELPDESK_BASE}/contacts`,
  contact: (id: string) => `${HELPDESK_BASE}/contacts/${id}`,
  workspace: `${HELPDESK_BASE}/workspace`,
  workspaceConversation: (id: string) => `${HELPDESK_BASE}/workspace?selected=${encodeURIComponent(id)}`,
  settings: `${HELPDESK_BASE}/settings`,
  settingsInboxes: `${HELPDESK_BASE}/settings/inboxes`,
  settingsUserSignature: `${HELPDESK_BASE}/settings/email-signature`,
  settingsInboxNew: `${HELPDESK_BASE}/settings/inboxes/new`,
  settingsInboxEdit: (id: string) => `${HELPDESK_BASE}/settings/inboxes/${id}/edit`,
  settingsBots: `${HELPDESK_BASE}/settings/bots`,
  settingsBotNew: `${HELPDESK_BASE}/settings/bots/new`,
  settingsBotEdit: (id: string, tab?: string) =>
    tab
      ? `${HELPDESK_BASE}/settings/bots/${id}/edit?tab=${encodeURIComponent(tab)}`
      : `${HELPDESK_BASE}/settings/bots/${id}/edit`,
  settingsGroups: `${HELPDESK_BASE}/settings/groups`,
  settingsLabels: `${HELPDESK_BASE}/settings/labels`,
  settingsCannedResponses: `${HELPDESK_BASE}/settings/canned-responses`,
  settingsNotifications: `${HELPDESK_BASE}/settings/notifications`,
  settingsIndicators: `${HELPDESK_BASE}/settings/indicators`,
  settingsGeneral: `${HELPDESK_BASE}/settings/general`,
};

export const HELPDESK_VALID_ROUTE_PREFIXES = [
  helpdeskRoutes.inbox,
  helpdeskRoutes.conversations,
  helpdeskRoutes.contacts,
  helpdeskRoutes.workspace,
  helpdeskRoutes.settings,
];
